import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ContractualTime } from '../../../../../core';

@JsonConverter
export class ContractualTimeAdapter implements JsonCustomConvert<ContractualTime | undefined> {
    serialize(contractualTime: ContractualTime): any | undefined {
        return contractualTime ? String(contractualTime) : undefined;
    }

    deserialize(contractualTime: any): ContractualTime | undefined {
        switch (contractualTime) {
            case '1A':
                return ContractualTime.LESS_1_YEAR;
            case '2A':
                return ContractualTime.BETWEEN_1_5_YEARS;
            case '3A':
                return ContractualTime.BETWEEN_5_10_YEARS;
            case '4A':
                return ContractualTime.MORE_10_YEARS;
            default:
                return undefined;
        }
    }
}
